import React from "react";
import styled from "styled-components";
import mondrian from "core/config/theme";

export const Container = styled.div`
  button {
    margin-bottom: ${mondrian.spacingStackXs};
  }
`;
export default function FormActions(props) {
  return <Container>{props.children}</Container>;
}
